import React, { useEffect } from 'react';
import GraphButton from '../../../GraphButton';
import {
  getNodeId,
  hasRelation,
  onBtnCollapse,
  onBtnExpand,
  onBtnFocus,
  onBtnMainLeaf,
  onNodeSuggestion,
  onRelationSelection,
  toggleChildren,
  toggleFatherBranch,
  toggleMotherBranch,
  toggleOthers,
} from '../../scripts/cy-core';

const NodeControl = () => {
  // suggest relation from keyword input
  function onRelationSuggestion(e) {
    const relationFilter = (aRelation) => {
      if (aRelation.id() === getNodeId()) {
        return false;
      }

      if (hasRelation(aRelation.id(), getNodeId())) {
        //      // debug-console.log('Skip relation suggestion: '+ aFather.data('name'));
        return true;
      }
      return false;
    };
    onNodeSuggestion(e, onRelationSelection, relationFilter);
  }

  useEffect(() => {
    // debug-console.log('[Use Effect] ---------');
    $('#destinationId').on('keyup', onRelationSuggestion);
    $('#destinationId').on('click', (e) => {
      onRelationSuggestion(e);
      e.stopPropagation();
    });
  }, []);

  return (
    <div id="nodeControl" className="tab-pane fade">
      <div className="hide">
        <label htmlFor="parentId">Parent : (Skiping feature) </label>
        <input
          type="text"
          className="form-control text-height-60"
          placeholder="parent"
          id="parentId"
          name="parent"
        />
      </div>
      <div>
        <GraphButton
          id="btnExpand"
          label="Phóng to"
          onClick={onBtnExpand}
          title="Phóng to Người đang chọn"
        />

        <GraphButton
          id="btnCollapse"
          label="Thu nhỏ"
          onClick={onBtnCollapse}
          title="Thu nhỏ Người đang chọn"
        />

        <GraphButton
          id="btnFocus"
          label="Tập trung"
          onClick={onBtnFocus}
          title="Quay trở lại vị trí Người đang chọn"
        />

        <GraphButton id="btnMainLeaf" label="Main Leaf" onClick={onBtnMainLeaf} className="hide" />
      </div>

      <table id="viewConfig">
        <tbody>
          <tr>
            <td>
              <input
                id="toggleFatherBranch"
                type="checkbox"
                defaultChecked
                onClick={toggleFatherBranch}
                title="Hiển thị họ nội của người đang chọn"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
              />
            </td>
            <td>
              <label htmlFor="viewFatherBranch">Họ nội</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                id="viewMotherBranch"
                type="checkbox"
                defaultChecked
                onClick={toggleMotherBranch}
                title="Hiển thị họ ngoại của người đang chọn"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
              />
            </td>
            <td>
              <label htmlFor="viewMotherBranch">Họ ngoại</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                id="viewChildren"
                type="checkbox"
                defaultChecked
                onClick={toggleChildren}
                title="Hiển thị con cháu của người hiện tại"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
              />
            </td>
            <td>
              <label htmlFor="viewChildren">Con cháu</label>
            </td>
          </tr>
          <tr>
            <td>
              <input
                id="viewOthers"
                type="checkbox"
                defaultChecked
                onClick={toggleOthers}
                title="Hiển thị những người không trong họ"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
              />
            </td>
            <td>
              <label htmlFor="viewOthers">Ngoài họ</label>
            </td>
          </tr>
        </tbody>
      </table>

      <div id="search-relation">
        <label htmlFor="destinationId">Tìm họ hàng: </label>
        <div>
          <input
            type="text"
            className="form-control text-height-60"
            placeholder="Tên họ hàng cần tìm"
            id="destinationId"
            name="destination"
          />
          <div className="suggestions" />
          {/* Thay bằng ấn vào suggestion
              <input id="btnSearchPath" type="submit" className="btn btn-primary btn-submit"
                      value="Tìm kiếm"
                      data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Tìm đường tới họ hàng từ Người đang chọn"> */}
        </div>
      </div>
      <div className="hide">
        <span>Quick add : </span>
        <input
          type="text"
          className="form-control text-height-60"
          defaultValue="0"
          id="targetCount"
          name="targetCount"
        />
        <input id="btnAddChild" type="submit" className="btn btn-primary btn-submit" value="Add" />
      </div>
    </div>
  );
};
export default NodeControl;
